import { render, staticRenderFns } from "./pricing-modal.vue?vue&type=template&id=90584ffe&scoped=true&"
import script from "./pricing-modal.vue?vue&type=script&lang=js&"
export * from "./pricing-modal.vue?vue&type=script&lang=js&"
import style0 from "./pricing-modal.vue?vue&type=style&index=0&id=90584ffe&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "90584ffe",
  null
  
)

export default component.exports